import { IXC_RAGL_V1_MANUAL_ENTRY_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-ragl-v1-manual-entry-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcRaglV1ManualEntryStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface RaglManualEntryStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcRaglV1ManualEntryStatus | undefined;
}

export function RaglManualEntryStatusPill({ isPending, status, ...props }: RaglManualEntryStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_RAGL_V1_MANUAL_ENTRY_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcRaglV1', enumName: 'IxcRaglV1ManualEntryStatus', value: status }} />
    </Pill>
  );
}
